import React from 'react'

const startButton = props => {
    let {
        codeReceived,
        tfaCodeRequestRequired,
        changesCount,
        handleCodeReceivedChange,
        RequestTFACode,
        TFAcodeReceived,
    } = props

    let translation = JSON.parse(localStorage.translation)[
        localStorage.language
    ]

    if (!codeReceived && tfaCodeRequestRequired) {
        return (
            <React.Fragment>
                <button
                    className={
                        changesCount
                            ? 'code-confirm__getCode_firstButton __active'
                            : 'code-confirm__getCode_firstButton'
                    }
                    style={{ marginLeft: '0' }}
                    onClick={
                        changesCount
                            ? () => {
                                  RequestTFACode({
                                      success: TFAcodeReceived,
                                  })
                              }
                            : null
                    }
                >
                    {translation['Get code']}
                </button>
                <button
                    className={
                        changesCount
                            ? 'code-confirm__getCode_secondButton __active'
                            : 'code-confirm__getCode_secondButton'
                    }
                    onClick={() => {
                        if (!changesCount) return null
                        handleCodeReceivedChange()
                    }}
                >
                    {translation['Enter the code']}
                </button>
            </React.Fragment>
        )
    } else {
        return null
    }
}

export default startButton
